import script from "./RequestClass.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestClass.vue?vue&type=script&setup=true&lang=js"

import "./RequestClass.vue?vue&type=style&index=0&id=6c01a19a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c01a19a"]])

export default __exports__